import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {CurrentTimeStore} from 'stores/current_time_store';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import TimeToStartTimer from 'app/utils/TimeToStartTimer';
import {SEC_IN_DAY} from 'app/utils/Consts';

interface PropsInterface {
    timeLeft: number;
    hideExpiredFreespin: () => void;
    currentTimeStore?: CurrentTimeStore;
}

@inject('currentTimeStore')
@observer
export default class FreespinsTimer extends Component<PropsInterface> {
    componentDidUpdate(): void {
        const {timeLeft, currentTimeStore, hideExpiredFreespin} = this.props;

        if (timeLeft > 0 && timeLeft <= currentTimeStore?.t) {
            hideExpiredFreespin();
        }
    }

    render(): React.ReactNode {
        const {timeLeft, currentTimeStore} = this.props;
        const {t} = currentTimeStore;
        const showDays = timeLeft - t >= SEC_IN_DAY;

        return <div className="freespins-item__timer">
            <SpriteIcon name="#svg-timer-icon" size={{height: 14, width: 14}}/>
            <span className="freespins-item__timer-text">
                <TimeToStartTimer time_to_start={timeLeft} showOnlyDays={showDays}/>
            </span>
        </div>;
    }
}
